const metaData = {
  fields: ['id', 'name', 'created_at', 'subject_id', 'topic_ids', 'theme_ids', { subject: ['name'] }, { work_requests: ['id'] }, { themes: ['id'] }],
}
export default metaData
